import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "more-widget-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "stat-box"
}
const _hoisted_3 = { class: "stat-description" }
const _hoisted_4 = { class: "stat-title" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "value text-aq-very-good" }
const _hoisted_8 = { class: "unit" }
const _hoisted_9 = {
  key: 1,
  class: "stat-box"
}
const _hoisted_10 = { class: "stat-description" }
const _hoisted_11 = { class: "stat-title m-0" }
const _hoisted_12 = { class: "stat-value" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "unit" }
const _hoisted_15 = {
  key: 2,
  class: "stat-box"
}
const _hoisted_16 = { class: "stat-description" }
const _hoisted_17 = { class: "stat-title m-0" }
const _hoisted_18 = { class: "date" }
const _hoisted_19 = { class: "stat-value" }
const _hoisted_20 = { class: "value text-aq-very-unhealty" }
const _hoisted_21 = { class: "unit" }
const _hoisted_22 = {
  key: 3,
  class: "empty"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "w-100 has-text-grey is-size-5 has-text-centered has-first-letter-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    widget: _ctx.widget,
    mode: _ctx.widgetMode,
    title: _ctx.$t('dashboard.more_widget.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.empty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.itemTitle(0)), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.minDate), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.min), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.unit), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (!_ctx.empty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.itemTitle(1)), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.mean), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.unit), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (!_ctx.empty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.itemTitle(2)), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.maxDate), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.max), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.unit), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.empty)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("img", {
                width: "50",
                src: require('@/no-data-icon.svg').default
              }, null, 8 /* PROPS */, _hoisted_23),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('dashboard.more_widget.not_enough_data')), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["widget", "mode", "title"]))
}